import { createFileRoute, redirect } from "@tanstack/react-router";

/** Permanent redirect: /tracker moved to the descriptive /job-tracker. */
export const Route = createFileRoute("/tracker")({
  beforeLoad: () => {
    throw redirect({ to: "/job-tracker", statusCode: 301 });
  },
});
